<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// $(document).ready(function(){
//     // $('#SortBy').val('price-ascending').trigger('change');
//     $('input#Filter-Availability-1[type="checkbox"][name="filter.v.availability"], #SortBy [value="created-ascending"]').click();
// });

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    // Handle added nodes
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.nodeValue.includes('\uFFFD')) {
          node.nodeValue = node.nodeValue.replaceAll('\uFFFD', '');
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        cleanElement(node);
      }
    });

    // Handle attribute changes
    if (mutation.type === 'attributes' && mutation.target) {
      const el = mutation.target;
      Array.from(el.attributes).forEach(attr => {
        if (attr.value.includes('\uFFFD')) {
          el.setAttribute(attr.name, attr.value.replaceAll('\uFFFD', ''));
        }
      });
    }

    // Handle direct text changes
    if (mutation.type === 'characterData' && mutation.target.nodeValue.includes('\uFFFD')) {
      mutation.target.nodeValue = mutation.target.nodeValue.replaceAll('\uFFFD', '');
    }
  });
});

function cleanElement(el) {
  // Clean text nodes
  el.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.nodeValue.includes('\uFFFD')) {
        node.nodeValue = node.nodeValue.replaceAll('\uFFFD', '');
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      cleanElement(node); // recursively clean children
    }
  });

  // Clean all attributes
  Array.from(el.attributes).forEach(attr => {
    if (attr.value.includes('\uFFFD')) {
      el.setAttribute(attr.name, attr.value.replaceAll('\uFFFD', ''));
    }
  });
}

// Clean existing content first
document.querySelectorAll('h1, h2, h3, p, span, li, td, div').forEach(cleanElement);

// Then observe for dynamic changes
observer.observe(document.body, {
  childList: true,       // watch for added/removed nodes
  subtree: true,         // watch all descendants
  attributes: true,      // watch attribute changes
  attributeOldValue: true,
  characterData: true,   // watch text changes
  characterDataOldValue: true
});

// Function to format search query to restrict search to title and variants.sku
function formatSearchQuery(term) {
  if (!term) return '';
  const cleanTerm = term.replace(/[^\w\s-]/g, '').trim();
  const words = cleanTerm.split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const titleQuery = words.map(w => `title:${w}*`).join(' AND ');
  const skuQuery = words.map(w => `variants.sku:${w}*`).join(' AND ');
  return `(${titleQuery}) OR (${skuQuery})`;
}

// Function to extract clean search term from formatted query
function getCleanSearchTerm(query) {
  if (!query) return '';
  if (query.includes('title:')) {
    const parts = query.split(' OR ');
    let firstPart = parts[0] || '';
    firstPart = firstPart.replace(/[()]/g, '').replace(/title:/g, '').replace(/\*/g, '').replace(/\s+AND\s+/gi, ' ').trim();
    return firstPart;
  }
  return query;
}

// Intercept form submissions
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.action && (form.action.includes('/search') || form.action.endsWith('/search'))) {
    const qInput = form.querySelector('input[name="q"]');
    if (qInput && qInput.value) {
      const originalValue = qInput.value.trim();
      if (originalValue && !originalValue.includes('title:')) {
        // Create a temporary hidden input with the formatted query
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'q';
        hiddenInput.value = formatSearchQuery(originalValue);
        form.appendChild(hiddenInput);
        
        // Remove the name from the visible input so it doesn't submit
        qInput.removeAttribute('name');
        
        // Restore the name attribute after a tiny delay so it behaves normally
        setTimeout(() => {
          qInput.setAttribute('name', 'q');
          hiddenInput.remove();
        }, 100);
      }
    }
  }
});

// Intercept search link clicks (e.g. suggestions list query clicks)
document.addEventListener('click', function(event) {
  const link = event.target.closest('a');
  if (link && link.href) {
    try {
      const url = new URL(link.href);
      if (url.pathname.includes('/search') || url.pathname.endsWith('/search')) {
        const qParam = url.searchParams.get('q');
        if (qParam && !qParam.includes('title:')) {
          const formatted = formatSearchQuery(qParam);
          url.searchParams.set('q', formatted);
          link.href = url.toString();
        }
      }
    } catch(e) {}
  }
});

// Clean up display values in search inputs and headings
function cleanSearchDisplay() {
  const params = new URLSearchParams(window.location.search);
  const qParam = params.get('q');
  if (qParam && qParam.includes('title:')) {
    const cleanTerm = getCleanSearchTerm(qParam);
    if (cleanTerm) {
      // 1. Clean up search inputs
      document.querySelectorAll('input[name="q"]').forEach(input => {
        input.value = cleanTerm;
      });

      // 2. Clean up page headings and breadcrumbs that might display the raw query
      document.querySelectorAll('.page-header, .page-subheader, .breadcrumb span, .resultTitle span, .collection-product-count').forEach(el => {
        if (el.textContent.includes('title:')) {
          const rawRegex = /\(?title:[^)]+\)?\s*OR\s*\(?variants\.sku:[^)]+\)?/gi;
          if (rawRegex.test(el.textContent)) {
            el.textContent = el.textContent.replace(rawRegex, cleanTerm);
          } else {
            el.textContent = el.textContent.replace(qParam, cleanTerm);
          }
        }
      });
    }
  }
}

// Run cleanup on page load and poll to catch dynamically rendered elements
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    cleanSearchDisplay();
    let count = 0;
    const interval = setInterval(() => {
      cleanSearchDisplay();
      if (++count > 30) clearInterval(interval); // Poll for 3 seconds
    }, 100);
  });
} else {
  cleanSearchDisplay();
  let count = 0;
  const interval = setInterval(() => {
    cleanSearchDisplay();
    if (++count > 30) clearInterval(interval);
  }, 100);
}